import React from 'react';

import { Account } from '../../../../generated-types';
import useTranslation from '../../../../hooks/useTranslation';
import AccountListItem from './AccountListItem';

import './FromAccountSelect.scss';

interface Props {
    id: string;
    showNegativeAmount: boolean;
    invalidItems: Account[];
    setOpen: (value: boolean) => void;
    open: boolean;
}

const InvalidAccountsList = ({ setOpen, open, id, showNegativeAmount, invalidItems }: Props) => {
    const { unavailableAccountsTitle } = useTranslation();

    return (
        <div
            className="invalid-accounts-list__wrapper"
            /*
            Shitty bike solution to prevent dropdown to collaps on click.
            Tried to prevent eventPropagation, but that did not work
            */
            onClick={() => setOpen(!open)}
            onKeyDown={() => setOpen(!open)}
        >
            <div className="inactive-header">
                <span> {unavailableAccountsTitle}</span>
            </div>
            <ul className="from-account-select__list">
                {invalidItems.map((item) => (
                    <AccountListItem
                        id={id}
                        key={id + item.accountId.value}
                        showNegativeAmount={showNegativeAmount}
                        item={item}
                    />
                ))}
            </ul>
        </div>
    );
};

export default InvalidAccountsList;
